import script from "./BulkOrderSelectInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./BulkOrderSelectInput.vue?vue&type=script&lang=ts&setup=true"

import "./BulkOrderSelectInput.vue?vue&type=style&index=0&id=94b69d6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94b69d6a"]])

export default __exports__